module.exports = __webpack_public_path__ + "packs/media/images/Profilerstellung-7c7664ca65d342dcfe332647a0bb3804.svg";